/**
  * @ngdoc service
  * @name common.store.service:StoreConfigurationService
  * @requires imLocatorService
  * @description
  * Favourites store are enabled only for registered users.
  * Management of CRUD operations.
*/

(function() {
    'use strict';

    angular
    .module('itxApp.common')
    .service('StoreConfigurationService', StoreConfigurationService);
    
    StoreConfigurationService.$inject = ['$q'];
    
    function StoreConfigurationService ($q) {
        var _this = this;

        _this.configuration=[
            {
                config: 'DELIVERY_TIME_STORE',
                value: '7-8'
            },{
                config:'ENABLED_NUM_PHYSICAL_STORES_BY_STORE',
                value: 0
            },{
                config:'RADIUS_SEARCH_STORE',
                value: 100
            },{
                config:'MIN_STORE_SEARCH_STORE',
                value: 10
            },
            {
                config: 'BAIDU_MAPS_KEY'
            }

        ];

        var service =  {
            getConfiguration: getConfiguration
        };
         
        return service;
    
        /**
         * @ngdoc method
         * @name getConfiguration
         * @methodOf  common.store.service:StoreConfigurationService
         * @description
         * Add selected physical store object to the user's favourite store list.
         * @param {object} physicalStore  Store object
         * @returns {promise} addFavouriteStore promise
        */
        function getConfiguration(){
            
            var deferred = $q.defer();

            var quantity=0;
            angular.forEach(_this.configuration, function(value, key){

                inditex.getXconfiguracionValue(value.config, function (status, result) {
                    quantity++;
                    if(result){
                        _this.configuration[key].value = result;
                    }

                    if(quantity==_this.configuration.length){
                        deferred.resolve(_this.configuration);
                    }
                });

            });

            return deferred.promise;

            // inditex.getXconfiguracionValue('ENABLED_NUM_PHYSICAL_STORES_BY_STORE', function (status, value) {
            //     _this.physicalStoreEnabled = parseInt(value);
            //     inditex.getXconfiguracionValue('MAX_NUM_PHYSICAL_STORES', function (status, value) {
            //         _this.maxStoreNumber = parseInt(value);
            //         _this.showSearchBar = _this.physicalStoreEnabled !== 1 || _this.storeNumber > _this.maxStoreNumber;
            //     });
            // });
            // return null;
        }

    }
        
})(window.itxApp);